<!-- 标题 -->
<template>
	<div class="item-title-box" :style="{marginTop: marginTop + 'px'}">
		<h2>{{ title }}</h2>
		<div class="title-line"></div>
		<router-link v-if="url" :to="url" class="look-all">查看全部></router-link>
	</div>
</template>

<script>
	export default {
		name: 'ItemTitle',
		props: {
			title: {
				type: String,
				default: ''
			},
			marginTop: {
				type: Number,
				default: 38
			},
			url: {
				type: String,
				default: undefined
			}
		}
	}
</script>

<style scoped>
	/* 标题 */
	.item-title-box {
		display: flex;
		align-items: flex-end;
		position: relative;
	}

	.item-title-box h2 {
		width: 126px;
		height: 44px;
		line-height: 44px;
		text-align: center;
		background: #2568F1;
		border-radius: 4px;
		color: #ffffff;
		font-size: 22px;
	}

	.item-title-box .title-line {
		flex: 1;
		height: 1px;
		background-color: #DEE1E7;
	}
	
	.look-all {
		position: absolute;
		top: 50%;
		right: 0;
		cursor: pointer;
		transform: translateY(-50%);
		color: #2568F1;
	}
</style>


// WEBPACK FOOTER //
// src/components/ItemTitle.vue